// extracted by mini-css-extract-plugin
export var alignCenter = "_8z-d";
export var bannerShown = "_8z-6";
export var buttonContent = "_8z-0";
export var cardList = "_8z-1";
export var centerContent = "_8z-2";
export var chevron = "_8z-3";
export var closePanelButton = "_8z-k";
export var conversationContextContainer = "_8z-l";
export var conversationDetailContainer = "_8z-4";
export var detailWrapper = "_8z-7";
export var dropdownButton = "_8z-e";
export var dropdownTitle = "_8z-9";
export var fullHeight = "_8z-5";
export var hidden = "_8z-a";
export var icon = "_8z-b";
export var mergeSuggestionWrapper = "_8z-m";
export var panel = "_8z-i";
export var portalButtonsWrapper = "_8z-c";
export var right = "_8z-j";
export var tableSummaryContainer = "_8z-8";
export var tableSummaryHeader = "_8z-g";
export var threeDotsButton = "_8z-f";
export var wide = "_8z-h";